import React from 'react';
import UserSettings from './UserSettings';

const Settings = () => {
  return <UserSettings />;
};

export default Settings;
